// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rights-settings {
  padding: 2rem;
  background: #f4f6f8;
  color: #334155;
}

.rights-settings-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: #004a9a;
  margin-bottom: 2rem;
  text-align: center;
}

.settings-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-width: 1000px;
  margin: 0 auto;
}

.settings-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border: 1px solid #e0e0e0;
}
.settings-card .card-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #004a9a;
  margin-bottom: 1.2rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #f1f1f1;
}

.rights-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
}

.rights-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background: #f9fafb;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  transition: all 0.3s ease;
}
.rights-item:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
}
.rights-item label {
  font-weight: 500;
  color: #475569;
  text-transform: capitalize;
  cursor: pointer;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
}
.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.toggle-switch input:checked + .toggle-slider {
  background-color: #004a9a;
}
.toggle-switch input:checked + .toggle-slider:before {
  transform: translateX(24px);
}
.toggle-switch input:focus + .toggle-slider {
  box-shadow: 0 0 1px #004a9a;
}
.toggle-switch .toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #c4c4c4;
  transition: 0.4s;
  border-radius: 34px;
}
.toggle-switch .toggle-slider:before {
  position: absolute;
  content: "";
  height: 22px;
  width: 22px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}
.toggle-switch .toggle-slider:hover {
  opacity: 0.9;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e2e8f0;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
}
.action-buttons .cancel-btn {
  background: #f1f1f1;
  color: #475569;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.action-buttons .cancel-btn:hover {
  background: #e2e8f0;
}
.action-buttons .save-btn {
  background: #004a9a;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}
.action-buttons .save-btn:hover:not(:disabled) {
  background: #003a7a;
}
.action-buttons .save-btn:disabled {
  background: #c4c4c4;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .rights-settings {
    padding: 1rem;
  }
  .rights-settings .rights-settings-title {
    font-size: 1.2rem;
  }
  .rights-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  .rights-grid .rights-item {
    padding: 0.875rem;
  }
  .action-buttons {
    flex-direction: column;
    gap: 0.75rem;
  }
  .action-buttons .cancel-btn,
  .action-buttons .save-btn {
    width: 100%;
    padding: 1rem;
  }
  .toggle-switch {
    width: 44px;
    height: 24px;
  }
  .toggle-switch input:checked + .toggle-slider:before {
    transform: translateX(20px);
  }
  .toggle-switch .toggle-slider:before {
    height: 20px;
    width: 20px;
  }
}
@media (max-width: 480px) {
  .rights-settings {
    padding: 0.75rem;
  }
  .settings-card {
    padding: 1rem;
  }
  .settings-card .card-title {
    font-size: 1.1rem;
  }
  .rights-item {
    padding: 0.75rem;
  }
  .rights-item label {
    font-size: 0.9rem;
  }
  .action-buttons .cancel-btn,
  .action-buttons .save-btn {
    font-size: 0.9rem;
    padding: 0.875rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/GlobalSettingsPage/RightsSettings/RightsSettings.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,mBAAA;EAEA,cAAA;AADF;;AAGA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;AAAF;;AAGA;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,0CAAA;EACA,yBAAA;AAAF;AAEE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,sBAAA;EACA,gCAAA;AAAJ;;AAIA;EACE,aAAA;EACA,2DAAA;EACA,WAAA;AADF;;AAIA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AADF;AAGE;EACE,mBAAA;EACA,qBAAA;AADJ;AAIE;EACE,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,eAAA;AAFJ;;AAMA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAHF;AAKE;EACE,UAAA;EACA,QAAA;EACA,SAAA;AAHJ;AAKI;EACE,yBAAA;AAHN;AAMI;EACE,2BAAA;AAJN;AAOI;EACE,2BAAA;AALN;AASE;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AAPJ;AASI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AAPN;AAUI;EACE,YAAA;AARN;;AAaA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAVF;AAYE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAVJ;AAYI;EACE,mBAAA;AAVN;AAcE;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AAZJ;AAcI;EACE,mBAAA;AAZN;AAeI;EACE,mBAAA;EACA,mBAAA;AAbN;;AAmBA;EACE;IACE,aAAA;EAhBF;EAkBE;IACE,iBAAA;EAhBJ;EAoBA;IACE,0BAAA;IACA,SAAA;EAlBF;EAoBE;IACE,iBAAA;EAlBJ;EAsBA;IACE,sBAAA;IACA,YAAA;EApBF;EAsBE;;IAEE,WAAA;IACA,aAAA;EApBJ;EAwBA;IACE,WAAA;IACA,YAAA;EAtBF;EAyBI;IACE,2BAAA;EAvBN;EA2BE;IACE,YAAA;IACA,WAAA;EAzBJ;AACF;AA6BA;EACE;IACE,gBAAA;EA3BF;EA8BA;IACE,aAAA;EA5BF;EA8BE;IACE,iBAAA;EA5BJ;EAgCA;IACE,gBAAA;EA9BF;EAgCE;IACE,iBAAA;EA9BJ;EAmCE;;IAEE,iBAAA;IACA,iBAAA;EAjCJ;AACF","sourcesContent":["// RightsSettings.scss - Updated to match ExpenseSettings design\n.rights-settings {\n  padding: 2rem;\n  background: #f4f6f8;\n  // min-height: 100vh;\n  color: #334155;\n}\n.rights-settings-title {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #004a9a;\n  margin-bottom: 2rem;\n  text-align: center;\n}\n\n.settings-container {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.settings-card {\n  background: white;\n  border-radius: 12px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  border: 1px solid #e0e0e0;\n\n  .card-title {\n    font-size: 1.2rem;\n    font-weight: 600;\n    color: #004a9a;\n    margin-bottom: 1.2rem;\n    padding-bottom: 0.5rem;\n    border-bottom: 1px solid #f1f1f1;\n  }\n}\n\n.rights-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1.5rem;\n}\n\n.rights-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  background: #f9fafb;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n\n  &:hover {\n    background: #f1f5f9;\n    border-color: #cbd5e1;\n  }\n\n  label {\n    font-weight: 500;\n    color: #475569;\n    text-transform: capitalize;\n    cursor: pointer;\n  }\n}\n\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 26px;\n\n  input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n\n    &:checked + .toggle-slider {\n      background-color: #004a9a;\n    }\n\n    &:checked + .toggle-slider:before {\n      transform: translateX(24px);\n    }\n\n    &:focus + .toggle-slider {\n      box-shadow: 0 0 1px #004a9a;\n    }\n  }\n\n  .toggle-slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #c4c4c4;\n    transition: 0.4s;\n    border-radius: 34px;\n\n    &:before {\n      position: absolute;\n      content: \"\";\n      height: 22px;\n      width: 22px;\n      left: 2px;\n      bottom: 2px;\n      background-color: white;\n      transition: 0.4s;\n      border-radius: 50%;\n    }\n\n    &:hover {\n      opacity: 0.9;\n    }\n  }\n}\n\n.action-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 2rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #e2e8f0;\n  max-width: 1000px;\n  margin-left: auto;\n  margin-right: auto;\n\n  .cancel-btn {\n    background: #f1f1f1;\n    color: #475569;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    padding: 0.75rem 1.5rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s;\n\n    &:hover {\n      background: #e2e8f0;\n    }\n  }\n\n  .save-btn {\n    background: #004a9a;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    padding: 0.75rem 1.5rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.2s;\n\n    &:hover:not(:disabled) {\n      background: #003a7a;\n    }\n\n    &:disabled {\n      background: #c4c4c4;\n      cursor: not-allowed;\n    }\n  }\n}\n\n// Responsive adjustments\n@media (max-width: 768px) {\n  .rights-settings {\n    padding: 1rem;\n\n    .rights-settings-title {\n      font-size: 1.2rem;\n    }\n  }\n\n  .rights-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n\n    .rights-item {\n      padding: 0.875rem;\n    }\n  }\n\n  .action-buttons {\n    flex-direction: column;\n    gap: 0.75rem;\n\n    .cancel-btn,\n    .save-btn {\n      width: 100%;\n      padding: 1rem;\n    }\n  }\n\n  .toggle-switch {\n    width: 44px;\n    height: 24px;\n\n    input {\n      &:checked + .toggle-slider:before {\n        transform: translateX(20px);\n      }\n    }\n\n    .toggle-slider:before {\n      height: 20px;\n      width: 20px;\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .rights-settings {\n    padding: 0.75rem;\n  }\n\n  .settings-card {\n    padding: 1rem;\n\n    .card-title {\n      font-size: 1.1rem;\n    }\n  }\n\n  .rights-item {\n    padding: 0.75rem;\n\n    label {\n      font-size: 0.9rem;\n    }\n  }\n\n  .action-buttons {\n    .cancel-btn,\n    .save-btn {\n      font-size: 0.9rem;\n      padding: 0.875rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
